<form (submit)="submit($event)" [formGroup]="formGroup">
  <div class="pb-6 flex flex-col gap-6">
    <zaeper-input-text [inputOptions]="nameInputTextOptions"></zaeper-input-text>
  </div>
  <div class="w-full flex gap-2 justify-end">
    <p-button [rounded]="true" type="submit">Speichern</p-button>
  </div>
</form>
